import { render, staticRenderFns } from "./Benefit.vue?vue&type=template&id=5e8cc8ee&lang=pug&"
import script from "./Benefit.vue?vue&type=script&lang=ts&"
export * from "./Benefit.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports